export default "<p>quran-and-science works!</p>\n"